import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  z-index: 999999;
  background-color: rgba(256, 256, 256, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Box = styled.div`
  background-color: ${Variables.colors.complementary};
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.2);
  width: 472.5px;
  padding: 16px;
  span {
    color: ${Variables.colors.complementary_900};
    font-size: ${Variables.font_sizes.x2_medium};
    margin-bottom: 26px;
    display: block;
    padding: 8px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      color: ${Variables.colors.complementary_700};
      border-radius: 4px;
      cursor: pointer;
      padding: 8px;
      display: flex;
      align-items: center;
      i {
        font-size: ${Variables.font_sizes.x2_large};
        margin-left: 6px;
      }
      .premium-icon{
        display: flex;
        margin-right: 8px;
        &:before{
          color: ${Variables.colors.yellow_500};
          font-size: 16px;
        }
      }
      &:hover {
        background-color: ${Variables.colors.primary_100};
        color: ${Variables.colors.primary_vivid};
      }
    }
    .selected {
      background-color: ${Variables.colors.primary_100};
      color: ${Variables.colors.primary_vivid};
    }
  }
`;
export const DateBox = styled.div`
  display: ${props => (props.status ? "block" : "none")};
  box-shadow: inset 0 2px 14px 0 rgba(0, 0, 0, 0.2);
  box-shadow: inset 0px 9px 12px -10px rgba(0, 0, 0, 0.2);
  padding: 8px 16px;
  margin: 8px -16px;
  span {
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.complementary_600};
    font-weight: 500;
    margin-bottom: 8px;
  }
  .text {
    width: 80%;
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.complementary_600};
    margin: 16px 0;
    line-height: 1.58;
  }
  button {
    float: left;
  }
`;
